import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import { DELIVERY_PARTNER_IDS_MAP, SHIPROCKET_DELIVERY_STEPS } from './constants';
import { getUserPatientAddresses } from './helper';
import DeliveryDetailsForm from './components/shiprocketForm/DeliveryDetailsForm';
import CourierDetailsForm from './components/shiprocketForm/CourierDetailsForm';
import BackButton from './components/BackButton';

const initialDeliveryData = {
    "orderId": "",
    "billingAddressId": "",
    "shippingAddressId": "",
    "recipientName": "",
    "recipientPhone": "",
    "packageDetails": {
        "name": "Medicines",
        "sku": "Medicines",
        "units": 1,
        "sellingPrice": 999,
        "length": 25,
        "breadth": 18,
        "height": 10,
        "weight": 0.9,
        "subTotal": 999
    },
    "courierId": "",
    "deliveryPartnerId": DELIVERY_PARTNER_IDS_MAP.SHIPROCKET,
}

const ShiprocketForm = ({ orderId, mapUserPatient, address, onClose, deliveryBoxImages = [] }) => {
    const [userPatientAddresses, setUserPatientAddresses] = useState([address]);
    const [deliveryData, setDeliveryData] = useState(initialDeliveryData);

    // Open-box photos live in the modal shell (DeliveryCreateModal) so all partner forms
    // share one field. Mirrored into `deliveryData` here because `deliveryData` IS the body
    // these forms POST -- no change to validation or the submit path itself.
    useEffect(() => {
        setDeliveryData((prevState) => ({ ...prevState, deliveryBoxImages }));
    }, [deliveryBoxImages]);
    const [currentStep, setCurrentStep] = useState(SHIPROCKET_DELIVERY_STEPS.DELIVERY_DETAILS);

    useEffect(() => {
        (async () => {
            if (mapUserPatient) {
                const res = await getUserPatientAddresses(mapUserPatient.id);
                if (res.length > 0) {
                    setUserPatientAddresses(res);
                }
            }
        })()
    }, [mapUserPatient]);

    useEffect(() => {
        setDeliveryData((prevState) => {
            return {
                ...prevState,
                orderId: orderId,
                billingAddressId: address.id,
                shippingAddressId: address.id,
            }
        });
    }, [])

    return (
        <div className='flex flex-col gap-[0.9rem]' >
            <div className='flex flex-col gap-[0.9rem]' >
                {
                    currentStep === SHIPROCKET_DELIVERY_STEPS.DELIVERY_DETAILS && <DeliveryDetailsForm deliveryData={deliveryData} setDeliveryData={setDeliveryData} userPatientAddresses={userPatientAddresses} mapUserPatient={mapUserPatient} onContinue={() => setCurrentStep(SHIPROCKET_DELIVERY_STEPS.SELECT_COURIER)} />
                }
                {
                    currentStep === SHIPROCKET_DELIVERY_STEPS.SELECT_COURIER && <CourierDetailsForm backButton={() => <BackButton onClick={() => setCurrentStep(SHIPROCKET_DELIVERY_STEPS.DELIVERY_DETAILS)} />} deliveryData={deliveryData} setDeliveryData={setDeliveryData} userPatientAddresses={userPatientAddresses} onContinue={onClose} />
                }
            </div>
        </div >
    )
}

ShiprocketForm.propTypes = {
    deliveryBoxImages: PropTypes.arrayOf(PropTypes.string),
    orderId: PropTypes.number.isRequired,
    mapUserPatient: PropTypes.object.isRequired,
    address: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ShiprocketForm